export const COLLECTION_SIZE_LIMIT = 25000;
export const COLLECTION_COUNT_LIMIT = 15;
export const WATCHLIST_SIZE_LIMIT = 1500;
export const SAVED_FILTERS_SIZE_LIMIT = 100;
export const COMPARE_LIMIT = 8;
export const MANAGE_QUANTITY_LIMIT = 50;
export const CUSTOM_INDEX_LIMIT = 5;

export const DEFAULT_USER = {
  role: 'user',
  employee: false,
  customerId: null,
  subscription: {},
  notificationSettings: {
    watchlist: true,
    watchlistMobile: true,
    collection: true,
    collectionMobile: true,
    saleApproval: true,
    saleApprovalMobile: true,
    dailyUpdates: true,
    dailyUpdatesMobile: true,
  },
  tutorials: {},
  dashboardWidgets: [
    { component: 'SalesVolumeWidget', visible: true },
    { component: 'SalesRecapWidget', visible: true },
    { component: 'ShopWidget', visible: true, savedFilterId: null },
    { component: 'HeadlinesWidget', visible: true },
    { component: 'CollectionWidget', visible: true, collectionId: null },
    { component: 'IndexWidget', visible: true },
  ],
  displayName: '',
  photoUrl: '',
  profileLink: '',
  locale: 'en-us',
  numCardsWatching: 0,
  numSavedFilters: 0,
  numComparisons: 0,
  hasUnreadNotifications: false,
  hideSalesHistoryValue: false,
  enableFuzzinessSearch: false,
  theme: 'light',
  recentSearches: {
    global: [],
  },
};

export const SELLING_PLATFORM_OPTIONS = [
  { value: 'eBay', label: 'eBay', url: 'https://www.ebay.com/b/Sports-Trading-Cards-Accessories/212/bn_1859819', shop: true, sales: true },
  { value: 'Fanatics-Weekly', label: 'Fanatics Weekly', url: 'https://www.fanaticscollect.com/', sales: true, shop: true },
  { value: 'Goldin', label: 'Goldin', url: 'https://goldin.co/', sales: true, shop: true },
  { value: 'Fanatics-Premier', label: 'Fanatics Premier', sales: true, shop: true },
  { value: 'Alt', label: 'Alt (Confirmed Paid)', sales: true, url: 'https://app.alt.xyz' },
  { value: 'Heritage', label: 'Heritage', url: 'https://www.ha.com/', sales: true, shop: true },
  { value: 'Fanatics-Vault', label: 'Fanatics Buy Now', sales: true, shop: true },
  { value: 'REA', label: 'REA', url: 'https://collectrea.com/', sales: true },
  { value: 'CardHobby', label: 'Card Hobby (Confirmed Paid)', url: 'https://www.cardhobby.com/#/', sales: true },
  { value: 'Lelands', label: 'Lelands', url: 'https://lelands.com/', sales: true },
  { value: 'AuctionOfChampions', label: 'Auction of Champions', url: 'https://www.auctionofchampions.com/', sales: true, shop: true },
  { value: 'Sothebys', label: 'Sothebys', sales: true },
  { value: 'MemoryLane', label: 'Memory Lane', url: 'https://memorylaneinc.com/', sales: true },
  { value: 'Pristine', label: 'Pristine Auction', url: 'https://www.pristineauction.com/', shop: true, sales: true },
  { value: 'HugginsAndScott', label: 'Huggins and Scott', url: 'https://hugginsandscott.com/', sales: true },
  { value: 'SCP', label: 'SCP', url: 'https://scpauctions.com/', sales: true },
  { value: 'MileHigh', label: 'Mile High', url: 'https://www.milehighcardco.com/', sales: true },
  { value: 'LoveOfTheGame', label: 'Love of the Game', url: 'https://loveofthegameauctions.com/', sales: true },
  { value: 'MySlabs', label: 'My Slabs', url: 'https://myslabs.com/', shop: true, sales: true },
  { value: '90sAuctions', label: '90s Auctions', url: 'https://90sauctions.com/', sales: true },
  { value: 'CollectAuctions', label: 'Collect Auctions', url: 'https://collectauctions.com/', sales: true },
  { value: 'SterlingSportsAuctions', label: 'Sterling Sports Auctions', sales: true },
  { value: 'JSPAuctions', label: 'JSP Auctions', url: 'https://jspauctions.com/', sales: true },
  { value: 'GoldenAgeAuctions', label: 'Golden Age Auctions', url: 'https://goldenageauctions.com/', sales: true },
  { value: 'WheatlandAuctions', label: 'Wheatland Auctions', url: 'https://wheatlandauctionservices.com/', sales: true },
  { value: 'CollectorInvestorAuctions', label: 'Collector Investor Auctions', url: 'https://collectorinvestorauctions.com/', sales: true },
  { value: 'ClassicAuctions', label: 'Classic Auctions', url: 'https://classicauctions.net/', sales: true },
  { value: 'Iconic', label: 'Iconic', url: 'https://www.iconicauctions.com/' },
  { value: 'Private', label: 'Private Sale', sales: true },
];

export const LISTING_TYPE_OPTIONS = [
  { value: 'Auction', label: 'Auction' },
  { value: 'BestOffer', label: 'Best Offer' },
  { value: 'FixedPrice', label: 'Fixed Price' },
];

export const REPORT_TYPE_OPTIONS = [
  { value: 'CARD_UPDATE', label: 'Card Updated' },
  { value: 'CARD_CREATE', label: 'Card Created' },
  { value: 'CARD_STATUS_REVIEW', label: 'Card Status in Review' },
  { value: 'CARD_STATUS_BACK_TO_PROGRESS', label: 'Card Back to Progress' },
  { value: 'CARD_ADMIT', label: 'Card Admitted' },
  { value: 'CARD_DELETE', label: 'Card Deleted' },
  { value: 'CARD_EBAY_SCRAPE', label: 'Card eBay Sraped' },
  { value: 'CARD_INITIAL_SALES_SCRAPE', label: 'Card Initial Scraped' },
  { value: 'CARD_POP_UPDATE', label: 'Card Pop Updated' },
  { value: 'CARD_SYNC_DAILY_SALES', label: 'Card Sales Synced' },
  { value: 'CARD_UPDATE_STATS', label: 'Card Stats Updated' },
  { value: 'PENDING_SALE_APPROVED', label: 'Pending Sale Approved' },
  { value: 'PENDING_SALE_MOVED_TO_PURGATORY', label: 'Pending Sale Moved to Purgatory' },
  { value: 'PENDING_SALE_DELETED', label: 'Pending Sale Deleted' },
  { value: 'PROFILE_MATCHED_MANUAL', label: 'Profile Matched (Manual)' },
  { value: 'PROFILE_MATCHED_AUTOMATIC', label: 'Profile Matched (Automatic)' },
  { value: 'PROFILE_SET_MATCH_SUGGESTED', label: 'Set-match suggestions' },
];

export const POST_CATEGORIES = [
  {
    value: 'Video', label: 'Videos', tooltip: 'Watch all the video content chosen specifically by Card Ladder',
  },
  {
    value: 'Podcast', label: 'Podcasts', tooltip: 'Listen to all the podcasts chosen specifically by Card Ladder',
  },
  {
    value: 'Headline', label: 'Headlines', tooltip: 'Show all headlines from the previous days activity',
  },
  {
    value: 'Sale', label: 'Sales Recap', tooltip: 'See all the sales recaps from the night before',
  },
  {
    value: 'Update', label: 'Updates', tooltip: 'View updates about Card Ladder',
  },
];

export const SOLD_OPTIONS = [
  { value: '', label: 'Collection Only' },
  { value: 'sold', label: 'Sold Only' },
  { value: 'all', label: 'Collection & Sold' },
];

export const VERIFIED_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'verified', label: 'Verified' },
  { value: 'unverified', label: 'Unverified' },
];

export const CERTIFIED_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'verifiedCert', label: 'Certified' },
  { value: 'switchedCardIdFromCert', label: 'Switcharoo' },
  { value: 'noMatchingCert', label: 'No Matching Card' },
  { value: 'noCert', label: 'No Cert' },
];

export const BEST_OFFER_STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'success', label: 'Remove Failed Best Offers' },
  { value: 'failed', label: 'Failed Best Offers' },
];

export const GRAPH_COLORS = [
  '#34BE8B',
  '#3398DB',
  '#9B59B6',
  '#EB4A4A',
  '#FF9957',
  '#B1A955',
  '#96A39E',
  '#907D70',
  '#FFD64D',
  '#7BC3F4',
  '#CA94E0',
  '#00774B',
  '#33D5DB',
  '#E8BB24',
  '#FFF4D0',
];

export const GRAPH_ZOOM_OPTIONS = [
  {
    value: 14, label: '2 weeks', shortLabel: '2W', isPublic: true,
  },
  {
    value: 31, label: '1 month', shortLabel: '1M', isPublic: true,
  },
  {
    value: 92, label: '3 months', shortLabel: '3M', isPublic: true,
  },
  {
    value: 183, label: '6 months', shortLabel: '6M',
  },
  {
    value: 365, label: '1 year', shortLabel: '1Y',
  },
  {
    value: 730, label: '2 years', shortLabel: '2Y',
  },
  { value: null, label: 'All-time', shortLabel: 'ALL' },
];

export const GRAPH_SCALE_OPTIONS = [
  { value: 'linear', label: 'Linear', tooltip: 'The linear graph shows absolute dollar change over time' },
  { value: 'logarithmic', label: 'Log', tooltip: 'The logarithmic graph shows rate of change over time' },
];

export const LADDER_SORT_OPTIONS = [
  'score',
  'currentValue',
  'marketValue',
  'pop',
  'marketCap',
  'gap',
  'priceMovement',
  'dailyPercentChange',
  'weeklyPercentChange',
  'monthlyPercentChange',
  'quarterlyPercentChange',
  'annualPercentChange',
  'numSales',
];

export const PENDING_SORT_OPTIONS = [
  'label',
  'date',
  'price',
  'platform',
];

export const WATCHLIST_SORT_OPTIONS = [
  'currentValue',
  'pop',
  'monthlyPercentChange',
  'priceMovement',
  'dateAdded',
  'score',
];

export const COLLECTION_SORT_OPTIONS = [
  'currentValue',
  'priceMovement',
  'dateAdded',
  'datePurchased',
  'profit',
  'year',
  'player',
  'label',
  'number',
];

export const PLAYERS_SORT_OPTIONS = [
  'dailySales',
  'totalCards',
  'totalMarketCap',
  'weeklyPercentChange',
  'monthlyPercentChange',
  'quarterlyPercentChange',
  'halfAnnualPercentChange',
  'yearToDatePercentChange',
  'annualPercentChange',
  'fiveYearPercentChange',
  'allTimePercentChange',
];

export const LISTING_SORT_OPTIONS = [
  'createdDate',
  'price',
  'watchers',
  'bids',
  'endDate',
];

export const SALES_SORT_OPTIONS = [
  'date',
  'price',
];

export const ADD_CARD_SORT_OPTIONS = [
  'dateAdded',
  'numSales',
  'currentValue',
  'pop',
];

export const SHOWCASE_SORT_OPTIONS = [
  'dateAdded',
  'label',
  'number',
  'numLikes',
];

export const SHOWCASE_COLLECTION_SORT_OPTIONS = [
  'dateAdded',
  'totalNumCards',
];

export const EMPLOYEE_SORT_OPTIONS = [
  'monthlyAddedCount',
  'monthlyMovedBackCount',
  'reviewCount',
  'totalAddedCount',
];

export const INDEXES_SORT_OPTIONS = [
  'weeklyPercentChange',
  'monthlyPercentChange',
  'quarterlyPercentChange',
  'halfAnnualPercentChange',
  'yearToDatePercentChange',
  'annualPercentChange',
  'fiveYearPercentChange',
  'allTimePercentChange',
];

export const CARD_STAT_FIELDS = [
  {
    value: 'currentValue', label: 'Value', format: 'currency', isPublic: false, tooltip: 'Card Ladder Value of the card using our proprietary algorithm',
  },
  {
    value: 'marketCap', label: 'Market Cap', format: 'currency', isPublic: true, tooltip: 'The Total Market Cap of the card, population multiplied by value',
  },
  {
    value: 'score', label: 'Score', format: 'decimal', isPublic: true, tooltip: 'The Ladder Score describes the growth of a card in the last 2 weeks',
  },
  {
    value: 'marketValue', label: 'Last Sold', format: 'currency', isPublic: true, tooltip: 'The last price this card was sold at',
  },
  {
    value: 'gap', label: 'Undervalued %', format: 'percentage', isPublic: false, tooltip: 'Undervalued gap is the percentage difference between last sold and the Card Ladder Value',
  },
  {
    value: 'pop', label: 'Pop', format: 'number', isPublic: false, tooltip: 'Total population of a card',
  },
  {
    value: 'priceMovement', label: 'Daily $ Change', format: 'currency', isPublic: false, tooltip: 'Real dollar amount this card moved today', showChange: true,
  },
  {
    value: 'dateAdded', label: 'Date Added', isPublic: true, format: 'date', tooltip: 'Most recently added', secondaryStat: true,
  },
  {
    value: 'datePurchased', label: 'Date Purchased', isPublic: true, format: 'date', tooltip: 'Date the card was purchased',
  },
  {
    value: 'dailyPercentChange', label: '1D % Change', format: 'percentage', isPublic: false, tooltip: 'The % change of value over the 24 hours', showChange: true,
  },
  {
    value: 'weeklyPercentChange', label: '1W % Change', format: 'percentage', isPublic: true, tooltip: 'The % change of value over the last week', showChange: true,
  },
  {
    value: 'monthlyPercentChange', label: '1M % Change', format: 'percentage', isPublic: true, tooltip: 'The % change value over the last month', showChange: true,
  },
  {
    value: 'quarterlyPercentChange', label: '3M % Change', format: 'percentage', isPublic: false, tooltip: 'The % change value over the last quarter', showChange: true,
  },
  {
    value: 'halfAnnualPercentChange', label: '6M % Change', format: 'percentage', isPublic: false, tooltip: 'The % change value over the last half year', showChange: true,
  },
  {
    value: 'yearToDatePercentChange', label: 'YTD % Change', format: 'percentage', isPublic: false, tooltip: 'The % change value since the beginning of this year', showChange: true,
  },
  {
    value: 'annualPercentChange', label: '1Y % Change', format: 'percentage', isPublic: false, tooltip: 'The % change value over the last year', showChange: true,
  },
  {
    value: 'fiveYearPercentChange', label: '5Y % Change', format: 'percentage', isPublic: false, tooltip: 'The % change value over the last 5 years', showChange: true,
  },
  {
    value: 'allTimePercentChange', label: 'Max % Change', format: 'percentage', isPublic: false, tooltip: 'The % change value since the beginning', showChange: true,
  },
  {
    value: 'numSales', label: 'Number of Sales', format: 'number', isPublic: false, tooltip: 'The total number of sales of a card',
  },
  {
    value: 'numLikes', label: 'Likes', format: 'number', isPublic: false, tooltip: 'The total number of times this card in showcase has been favorited',
  },
  {
    value: 'dailySales', label: '24H Volume', format: 'currency', tooltip: 'Sort by the players with the most volume of sales in the last 24 hours', isPublic: true,
  },
  {
    value: 'dateSubmitted', label: 'Date Submitted', format: 'datetime', tooltip: 'Order the cards were submitted by date',
  },
  {
    value: 'profit', label: 'Profit', format: 'currency', tooltip: 'Amount of potential profit of the card', showChange: true,
  },
  {
    value: 'investment', label: 'Investment', format: 'currency', tooltip: 'Amount of investment into the card',
  },
  {
    value: 'priceSold', label: 'Price Sold', format: 'currency', tooltip: 'Amount the card was sold for',
  },
  {
    value: 'watchers', label: 'Watchers', format: 'number', tooltip: 'Sort by the listings with the most watchers', isPublic: true,
  },
  {
    value: 'bids', label: 'Bids', format: 'number', tooltip: 'Sort by the listings with the most bids', isPublic: true,
  },
  {
    value: 'price', label: 'Price', format: 'currency', tooltip: 'Sort by the listings with the the highest price', isPublic: true, formatOptions: { full: true },
  },
  {
    value: 'endTime', label: 'Time Left', format: 'date', tooltip: 'Sort by the listings ending soonest', isPublic: true,
  },
  {
    value: 'endDate', label: 'Time Left', format: 'datetime', tooltip: 'Sort by the listings ending soonest', isPublic: false,
  },
  {
    value: 'updatedDate', label: 'Recently Updated', format: 'date', tooltip: 'Most recently updated', isPublic: false,
  },
  {
    value: 'createdDate', label: 'Recently Added', format: 'date', tooltip: 'Most recently added', isPublic: false,
  },
  {
    value: 'date', label: 'Date Sold', format: 'date', tooltip: 'Sort by the end date of the sales', isPublic: false,
  },
  {
    value: 'label', label: 'Alphabetical', format: 'string', tooltip: 'Sort alphabetically', isPublic: false, secondaryStat: true,
  },
  {
    value: 'totalCards', label: '# of Cards', format: 'number', tooltip: '# of Cards', isPublic: false,
  },
  {
    value: 'totalMarketCap', label: 'Total Market Cap', format: 'currency', tooltip: 'Total Market Cap', isPublic: false,
  },
  {
    value: 'totalNumCards', label: '# of Cards', format: 'number', tooltip: '# of Cards',
  },
  {
    value: 'listingType', label: 'Type', format: 'string', tooltip: 'Listing type of the listing', isPublic: true,
  },
  {
    value: 'platform', label: 'Platform', format: 'string', tooltip: 'Platform of the listing', isPublic: true,
  },
  {
    value: 'displayName', label: 'Owner', format: 'string', tooltip: 'Owner of the item', isPublic: true,
  },
  {
    value: 'year', label: 'Year', format: 'string', tooltip: 'Sort by year', isPublic: false, secondaryStat: true,
  },
  {
    value: 'player', label: 'Player', format: 'string', tooltip: 'Sort by player', isPublic: false, secondaryStat: true,
  },
  {
    value: 'number', label: 'Number', format: 'string', tooltip: 'Card # in the set', isPublic: false,
  },
  {
    value: 'monthlyAddedCount', label: 'Added Monthly', format: 'number', tooltip: 'Number of cards added to the database this month', isPublic: false,
  },
  {
    value: 'monthlyMovedBackCount', label: 'Back Monthly', format: 'number', tooltip: 'Number of cards moved back to progress', isPublic: false,
  },
  {
    value: 'reviewCount', label: 'Cards in Review', format: 'number', tooltip: 'Number of cards in review', isPublic: false,
  },
  {
    value: 'totalAddedCount', label: 'Total Added', format: 'number', tooltip: 'Number of cards added to the database', isPublic: false,
  },
];

export const DEFAULT_CARD_DETAILS = {
  id: null,
  image: null,
  player: '',
  year: '',
  set: '',
  variation: '',
  number: '',
  category: null,
  condition: null,
  profileId: null,
  grader: null,
  grade: null,
  autographGrade: null,
  qualifierType: null,
  employee: '',
  ebayQuery: '',
  pop: null,
  popLastUpdated: new Date(1970, 1, 1),
  cert: '',
  setInformation: '',
  setInformationLinkUrl1: '',
  setInformationLinkDescription1: '',
  cardInformation: '',
  cardInformationLinkUrl1: '',
  cardInformationLinkDescription1: '',
  keyCard: false,
  auctionOnly: false,
  autoAddSales: false,
  manuallyReviewSales: false,
  popIgnore: false,
  hidden: false,
};

export const DEFAULT_CARD_COLLECTION = {
  investment: 100,
  estimatedCurrentValue: 0,
  quantity: 1,
  quantitySold: 0,
  hasQuantityAvailable: true,
  willManageQuantity: false,
  individualCards: [],
  datePurchased: new Date(),
  sold: false,
  dateSold: new Date(),
  priceSold: 200,
  notes: '',
  priceMovement: 0,
  useLastSoldValue: false,
  useGradedCardAutomatic: false,
  ownsPercentage: false,
  ownershipPercentage: 100,
  tags: [],
};

export const DEFAULT_COLLECTION_DATA = {
  numCards: 0,
  totalNumCards: 0,
  totalValue: 0,
  totalInvestment: 0,
  totalNumSoldCards: 0,
  totalSoldValue: 0,
  totalSoldInvestment: 0,
  public: false,
  dateAdded: new Date(),
};

export const DEFAULT_CARD_FILTERS = {
  minValue: null,
  maxValue: null,
  categories: [],
  conditions: [],
  minYear: null,
  maxYear: null,
};

export const DEFAULT_LADDER_FILTERS = {
  minValue: null,
  maxValue: null,
  categories: [],
  conditions: [],
  minYear: null,
  maxYear: null,
  minPop: null,
  maxPop: null,
  employee: 'all',
};

export const DEFAULT_COLLECTION_FILTERS = {
  minValue: null,
  maxValue: null,
  categories: [],
  tags: [],
  minYear: null,
  maxYear: null,
  sold: '',
  verified: 'all',
};

export const DEFAULT_ADD_CARD_FILTERS = {
  minValue: null,
  maxValue: null,
  categories: [],
  conditions: [],
  minYear: null,
  maxYear: null,
  employee: 'all',
  status: 'review',
};

export const DEFAULT_SALES_FILTERS = {
  minPrice: null,
  maxPrice: null,
  minDate: null,
  maxDate: null,
  platforms: [],
  listingType: 'all',
  verified: 'all',
  seller: '',
  condition: '',
  profileId: '',
  grader: '',
};

export const DEFAULT_SHOP_FILTERS = {
  minPrice: null,
  maxPrice: null,
  minDate: null,
  maxDate: null,
  platforms: [],
  listingType: 'all',
};

export const DEFAULT_PENDING_FILTERS = {
  platforms: [],
  conditions: [],
  listingType: 'all',
  employee: 'all',
  status: 'review',
  certified: 'all',
  bestOfferStatus: 'all',
};

export const DEFAULT_SHOWCASE_FILTERS = {
  categories: [],
  conditions: [],
  minYear: null,
  maxYear: null,
};

export const DEFAULT_CUSTOM_INDEX_FILTERS = {
  minValue: null,
  maxValue: null,
  category: null,
  conditions: [],
  minYear: null,
  maxYear: null,
  player: '',
};

export const DEFAULT_PLAYER_INDEX_FILTERS = {
  categories: [],
  minCards: null,
  maxCards: null,
};

export const GRADER_OPTIONS = [
  { value: 'psa', label: 'PSA' },
  { value: 'beckett', label: 'BECKETT' },
  { value: 'sgc', label: 'SGC' },
  { value: 'cgc', label: 'CGC' },
];

export const DEFAULT_PROFILE_SEARCH_FILTERS = {
  graders: [],
  hasMatches: 'all',
  categories: [],
};

export const EMAIL_BLACKLIST = ['ioxmail.net', 'djemail.net', 'gomail5.com', 'mailerv.net', 'chikd73.com', 'entrastd.com'];

export const PRO_FEATURES = [
  {
    icon: 'style',
    name: 'Collection Portfolio',
    description: 'Track the value of your collection daily, even the ones you own that aren\'t in our system.',
  },
  {
    icon: 'addchart',
    name: 'All-time Sales History',
    description: 'View the all-time sales history of all cards in our database',
  },
  {
    icon: 'calculate',
    name: 'Predictive Pricing',
    description: 'Using our proprietary algorithm, we give you accurate estimates on millions of cards.',
  },
  {
    icon: 'camera',
    name: 'Camera Search',
    description: 'Use your camera to snap a pic of any card and get fast, accurate pricing results.',
  },
  {
    icon: 'space_dashboard',
    name: 'Personal Dashboard',
    description: 'Organize your day with this home base. Get a quick snapshot of the day in cards.',
  },
  {
    icon: 'rss_feed',
    name: 'Feed',
    description: 'The front page of the hobby. See daily sales, interesting articles, and other relevant content.',
  },
  {
    icon: 'visibility',
    name: 'Watchlist',
    description: 'Is there a card in our system that you have your eye on? Add it to your watchlist to track its performance.',
  },
  {
    icon: 'multiline_chart',
    name: 'Card Comparisons',
    description: 'Quickly plot full sales histories of any card against another. You can even save them for later usage.',
  },
  {
    icon: 'medical_services',
    name: 'Industry Data',
    description: 'High level industry data around the secondary market',
  },
  {
    icon: 'filter_alt',
    name: 'Filtering & Sorting',
    description: 'Quickly find cards that are relevant to you by filtering by price, sport, set, year, and more.',
  },
  {
    icon: 'travel_explore',
    name: 'Showcase',
    description: 'Showcase is the only search bar into private collections that exists in the hobby.',
  },
  {
    icon: 'tv_off',
    name: 'No Ads, Ever',
    description: 'Enjoy the full suite of Card Ladder Pro features without the ads, forever.',
  },
  {
    icon: 'system_update',
    name: 'All Future Updates',
    description: 'As we roll out new features, you\'ll get access first, helping you stay ahead of the competition.',
  },
];

export const DASHBOARD_WIDGETS = {
  SalesVolumeWidget: { name: 'Monthly Volume' },
  SalesRecapWidget: { name: 'Daily Sales Recap' },
  ShopWidget: { name: 'Shop', isPublic: true },
  HeadlinesWidget: { name: 'Ladder Headlines' },
  CollectionWidget: { name: 'Collection Update' },
  IndexWidget: { name: 'CL50 Index' },
};

export const FEATURE_TABLE = [
  /* Free */
  { name: 'Price Guide', description: 'Search card values and statistics', free: true },
  { name: 'Shop', description: 'Shop cards from multiple platforms', free: true },
  { name: 'Showcase', description: 'Share a link to your collection with anyone', free: true },
  { name: 'Feed', description: 'Read daily hobby news, content, and headlines', free: true },
  { name: 'Daily Sales Recap', description: 'Browse all verified sales from the previous day', free: true },
  { name: 'Indexes', description: 'Research thousands of unique market indexes', free: true },

  /* Pro */
  { name: 'Sales History', description: 'View all-time sales history for millions of cards', free: false },
  { name: 'Collection', description: 'Upload your collection and get daily value estimates', free: false },
  { name: 'CL Value', description: 'Check estimated pricing for any card', free: false },
  { name: 'Camera Search', description: 'Use your camera to search millions of cards', free: false },
  { name: 'Population Reports', description: 'View full population reports for all graded cards including growth over time', free: false },
  { name: 'Watchlist', description: `Configure price alerts for cards you're watching`, free: false },
  { name: 'Dashboard', description: 'Access your own customizable dashboard', free: false },
  { name: 'Custom Indexes', description: 'Create your own custom index to study the market', free: false },
  { name: 'Advanced Searching', description: 'Dig deeper with advanced searching, filtering and sorting', free: false },
  { name: 'Showcase', description: 'Share your collection as a showcase for others to view', free: false },
  { name: 'Compare', description: 'Get in-depth comparisons of multiple cards and indexes', free: false },
  { name: 'Industry', description: 'Research high-level secondary market data', free: false },
];

export const QUERY_KEYWORDS = {
  all: [
    'Lot',
    'Lots',
    'Bonus',
    'Extras',
    'Extra',
    'More',
    'Also',
    'Additional',
    'Choose',
    'Reprint',
    'Reprints',
    'RP',
    'RPs',
    'Reproduction',
    'Reproductions',
    'Repro',
    'Repros',
    'Replica',
    'Full',
    'Entire',
    'Complete',
    'Partial',
  ],
};

export const CATEGORY_OPTIONS = [
  { value: 'Basketball', label: 'Basketball', icon: 'sports_basketball' },
  { value: 'Baseball', label: 'Baseball', icon: 'sports_baseball' },
  { value: 'Football', label: 'Football', icon: 'sports_football' },
  { value: 'Pokemon', label: 'Pokemon', icon: 'catching_pokemon' },
  { value: 'OnePiece', label: 'One Piece', icon: 'cl_onepiece' },
  { value: 'Hockey', label: 'Hockey', icon: 'sports_hockey' },
  { value: 'Soccer', label: 'Soccer', icon: 'sports_soccer' },
  { value: 'Marvel', label: 'Marvel', icon: 'token' },
  { value: 'MultiSport', label: 'Multi-Sport', icon: 'sports' },
  { value: 'UFC/MMA', label: 'UFC/MMA', icon: 'cl_ufc' },
  { value: 'Wrestling', label: 'Wrestling', icon: 'sports_kabaddi' },
  { value: 'Yugioh', label: 'Yu-Gi-Oh!', icon: 'cl_yugioh' },
  { value: 'Golf', label: 'Golf', icon: 'sports_golf' },
  { value: 'Tennis', label: 'Tennis', icon: 'sports_tennis' },
  { value: 'WNBA', label: 'WNBA', icon: 'woman' },
  { value: 'Magic', label: 'Magic the Gathering', icon: 'cl_mtg' },
  { value: 'Disney', label: 'Disney', icon: 'castle' },
  { value: 'Racing', label: 'Racing', icon: 'sports_score' },
  { value: 'Fortnite', label: 'Fortnite', icon: 'cl_fortnite' },
  { value: 'Dragonballz', label: 'Dragonball Z', icon: 'cl_dragonballz' },
  { value: 'Entertainment', label: 'Entertainment', icon: 'mic_external_on' },
  { value: 'StarWars', label: 'Star Wars', icon: 'cl_starwars' },
  { value: 'Swimming', label: 'Swimming', icon: 'pool' },
  { value: 'Softball', label: 'Softball', icon: 'cl_softball' },
  { value: 'PopCulture', label: 'Pop Culture', icon: 'music_note' },
  { value: 'Historical', label: 'Historical', icon: 'castle' },
  { value: 'Boxing', label: 'Boxing', icon: 'sports_mma' },
  { value: 'Metazoo', label: 'MetaZoo', icon: 'cl_metazoo' },
  { value: 'FleshAndBlood', label: 'Flesh and Blood', icon: 'bloodtype' },
];

export const ALL_GRADING_EXCLUSIONS = ['GMA', 'SCD', 'GAI', 'CEX', 'FGS', 'PGI', 'CSA', 'CGA', 'KSA', 'EGS', 'AGS', 'BSG', 'TFA', 'PGA', 'AGA', 'DCS', 'CGI', 'ISA', 'PBI', 'RCG', 'SBC', 'DGA', 'TGA', 'WCG', 'DSG', 'VGT', 'PCA', 'MGC', 'AGC', 'PGS', 'FCG'];

export const GRADING_COMPANIES = [
  { value: 'psa', label: 'PSA', altNames: [], exclusions: ['Beckett', 'BGS', 'BVG', 'BCCG', 'RCR', 'SGC', 'HGA', 'CSG', 'CGC', 'CCG'] },
  { value: 'bgs', label: 'BGS', altNames: ['Beckett'], exclusions: ['BCCG', 'RCR', 'SGC', 'HGA', 'CSG', 'CGC', 'CCG'] },
  { value: 'bvg', label: 'BVG', altNames: [], exclusions: ['BCCG', 'RCR'] },
  { value: 'sgc', label: 'SGC', altNames: [], exclusions: ['HGA', 'CSG', 'CGC', 'CCG'] },
  { value: 'hga', label: 'HGA', altNames: [], exclusions: [] },
  { value: 'tag', label: 'TAG', altNames: [], exclusions: [] },
  { value: 'csg', label: 'CSG', altNames: [], exclusions: [] },
  { value: 'other', label: 'Other', altNames: [], exclusions: [] },
  { value: 'raw', label: 'Raw', altNames: [], exclusions: ['Graded', 'PSA', 'Beckett', 'BGS', 'BVG', 'BCCG', 'RCR', 'SGC', 'HGA', 'CSG', 'CGC'] },
];

export const CONDITION_OPTIONS = [
  { value: 'BGS 10 Black', label: 'BGS 10 - Pristine (Black Label)', gradingCompany: 'bgs' },
  { value: 'SGC 10 Pristine', label: 'SGC 10 - Pristine', gradingCompany: 'sgc', queryValue: 'SGC (10,100)' },
  { value: 'CGC 10 Perfect', label: 'CGC 10 - Perfect', gradingCompany: 'cgc' },
  { value: 'PSA 10', label: 'PSA 10 - Gem Mint', gradingCompany: 'psa' },
  { value: 'BGS 10', label: 'BGS 10 - Pristine', gradingCompany: 'bgs' },
  { value: 'SGC 10', label: 'SGC 10 - Gem Mint', gradingCompany: 'sgc', queryValue: 'SGC (10,98)' },
  { value: 'CGC 10 Pristine', label: 'CGC 10 - Pristine', gradingCompany: 'cgc' },
  { value: 'CGC 10', label: 'CGC 10 - Gem Mint', gradingCompany: 'cgc' },
  { value: 'PSA 10/Auto 10', label: 'PSA 10/Auto 10 - Gem Mint', gradingCompany: 'psa', queryValue: 'PSA 10' },
  { value: 'PSA 10/Auto 9', label: 'PSA 10/Auto 9 - Gem Mint', gradingCompany: 'psa', queryValue: 'PSA 10' },
  { value: 'PSA 10/Auto 8', label: 'PSA 10/Auto 8 - Gem Mint', gradingCompany: 'psa', queryValue: 'PSA 10' },
  { value: 'PSA 10/Auto Auth', label: 'PSA 10/Auto Auth - Gem Mint', gradingCompany: 'psa', queryValue: 'PSA 10' },
  { value: 'BGS 10/Auto 10', label: 'BGS 10/Auto 10 - Pristine', gradingCompany: 'bgs', queryValue: 'BGS 10' },
  { value: 'SGC 10/Auto 10', label: 'SGC 10/Auto 10 - Gem Mint', gradingCompany: 'sgc', queryValue: 'SGC (10,98)' },
  { value: 'BGS 9.5', label: 'BGS 9.5 - Gem Mint', gradingCompany: 'bgs' },
  { value: 'SGC 9.5', label: 'SGC 9.5 - Mint+', gradingCompany: 'sgc' },
  { value: 'CGC 9.5 Gem Mint', label: 'CGC 9.5 - Gem Mint', gradingCompany: 'cgc' },
  { value: 'CGC 9.5', label: 'CGC 9.5 - Mint+', gradingCompany: 'cgc' },
  { value: 'BGS 9.5/Auto 10', label: 'BGS 9.5/Auto 10 - Gem Mint', gradingCompany: 'bgs', queryValue: 'BGS 9.5' },
  { value: 'SGC 9.5/Auto 10', label: 'SGC 9.5/Auto 10 - Mint+', gradingCompany: 'sgc' },
  { value: 'BGS 9.5/Auto 9', label: 'BGS 9.5/Auto 9 - Gem Mint', gradingCompany: 'bgs', queryValue: 'BGS 9.5' },
  { value: 'PSA 9', label: 'PSA 9 - Mint', gradingCompany: 'psa' },
  { value: 'BGS 9', label: 'BGS 9 - Mint', gradingCompany: 'bgs' },
  { value: 'SGC 9', label: 'SGC 9 - Mint', gradingCompany: 'sgc', queryValue: 'SGC (9,96)' },
  { value: 'CGC 9', label: 'CGC 9 - Mint', gradingCompany: 'cgc' },
  { value: 'PSA 9/Auto 10', label: 'PSA 9/Auto 10 - Mint', gradingCompany: 'psa', queryValue: 'PSA 9' },
  { value: 'PSA 9/Auto 9', label: 'PSA 9/Auto 9 - Mint', gradingCompany: 'psa', queryValue: 'PSA 9' },
  { value: 'PSA 9/Auto Auth', label: 'PSA 9/Auto Auth - Mint', gradingCompany: 'psa', queryValue: 'PSA 9' },
  { value: 'PSA 9/Auto 8', label: 'PSA 9/Auto 8 - Mint', gradingCompany: 'psa', queryValue: 'PSA 9' },
  { value: 'BGS 9/Auto 10', label: 'BGS 9/Auto 10 - Mint', gradingCompany: 'bgs', queryValue: 'BGS 9' },
  { value: 'BGS 9/Auto 9', label: 'BGS 9/Auto 9 - Mint', gradingCompany: 'bgs', queryValue: 'BGS 9' },
  { value: 'SGC 9/Auto 10', label: 'SGC 9/Auto 10 - Mint', gradingCompany: 'sgc', queryValue: 'SGC (9,96)' },
  { value: 'Raw', label: 'Raw', queryValue: '', gradingCompany: 'raw' },
  { value: 'PSA 8.5', label: 'PSA 8.5 - NM-MT+', gradingCompany: 'psa' },
  { value: 'BGS 8.5', label: 'BGS 8.5 - NM-MT+', gradingCompany: 'bgs' },
  { value: 'CGC 8.5', label: 'CGC 8.5 - NM-MT+', gradingCompany: 'cgc' },
  { value: 'SGC 8.5', label: 'SGC 8.5 - NM-MT+', gradingCompany: 'sgc', queryValue: 'SGC (8.5,92)' },
  { value: 'PSA 8.5/Auto 10', label: 'PSA 8.5/Auto 10 - NM-MT+', gradingCompany: 'psa', queryValue: 'PSA 8.5' },
  { value: 'BGS 8.5/Auto 10', label: 'BGS 8.5/Auto 10 - NM-MT+', gradingCompany: 'bgs', queryValue: 'BGS 8.5' },
  { value: 'SGC 8.5/Auto 10', label: 'SGC 8.5/Auto 10 - Mint', gradingCompany: 'sgc', queryValue: 'SGC (8.5,92)' },
  { value: 'PSA 8', label: 'PSA 8 - NM-MT', gradingCompany: 'psa' },
  { value: 'BGS 8', label: 'BGS 8 - NM-MT', gradingCompany: 'bgs' },
  { value: 'SGC 8', label: 'SGC 8 - NM-MT', gradingCompany: 'sgc', queryValue: 'SGC (8,88)' },
  { value: 'CGC 8', label: 'CGC 8 - NM-MT', gradingCompany: 'cgc' },
  { value: 'PSA 8/Auto 10', label: 'PSA 8/Auto 10 - NM-MT', gradingCompany: 'psa', queryValue: 'PSA 8' },
  { value: 'PSA 8/Auto 9', label: 'PSA 8/Auto 9 - NM-MT', gradingCompany: 'psa', queryValue: 'PSA 8' },
  { value: 'PSA 8/Auto Auth', label: 'PSA 8/Auto Auth - NM-MT', gradingCompany: 'psa', queryValue: 'PSA 8' },
  { value: 'PSA 8/Auto 8', label: 'PSA 8/Auto 8 - NM-MT', gradingCompany: 'psa', queryValue: 'PSA 8' },
  { value: 'BGS 8/Auto 10', label: 'BGS 8/Auto 10 - NM-MT', gradingCompany: 'bgs', queryValue: 'BGS 8' },
  { value: 'SGC 8/Auto 10', label: 'SGC 8/Auto 10 - Mint', gradingCompany: 'sgc', queryValue: 'SGC (8,88)' },
  { value: 'PSA 7.5', label: 'PSA 7.5 - NM+', gradingCompany: 'psa' },
  { value: 'BGS 7.5', label: 'BGS 7.5 - NM+', gradingCompany: 'bgs' },
  { value: 'SGC 7.5', label: 'SGC 7.5 - NM+', gradingCompany: 'sgc', queryValue: 'SGC (7.5,86)' },
  { value: 'CGC 7.5', label: 'CGC 7.5 - NM+', gradingCompany: 'cgc' },
  { value: 'BGS 7.5/Auto 10', label: 'BGS 7.5/Auto 10 - NM+', gradingCompany: 'bgs', queryValue: 'BGS 7.5' },
  { value: 'PSA 7', label: 'PSA 7 - NM', gradingCompany: 'psa' },
  { value: 'BGS 7', label: 'BGS 7 - NM', gradingCompany: 'bgs' },
  { value: 'SGC 7', label: 'SGC 7 - NM', gradingCompany: 'sgc', queryValue: 'SGC (7,84)' },
  { value: 'CGC 7', label: 'CGC 7 - NM', gradingCompany: 'cgc' },
  { value: 'PSA 7/Auto 10', label: 'PSA 7/Auto 10 - NM', gradingCompany: 'psa', queryValue: 'PSA 7' },
  { value: 'BGS 7/Auto 10', label: 'BGS 7/Auto 10 - NM', gradingCompany: 'bgs', queryValue: 'BGS 7' },
  { value: 'SGC 7/Auto 10', label: 'SGC 7/Auto 10 - Mint', gradingCompany: 'sgc', queryValue: 'SGC (7,84)' },
  { value: 'PSA 6.5', label: 'PSA 6.5 - EX-NM+', gradingCompany: 'psa' },
  { value: 'BGS 6.5', label: 'BGS 6.5 - EX-NM+', gradingCompany: 'bgs' },
  { value: 'SGC 6.5', label: 'SGC 6.5 - EX-NM+', gradingCompany: 'sgc', queryValue: 'SGC (6.5,82)' },
  { value: 'CGC 6.5', label: 'CGC 6.5 - EX-NM+', gradingCompany: 'cgc' },
  { value: 'BGS 6.5/Auto 10', label: 'BGS 6.5/Auto 10 - EX-NM+', gradingCompany: 'bgs', queryValue: 'BGS 6.5' },
  { value: 'PSA 6', label: 'PSA 6 - EX-NM', gradingCompany: 'psa' },
  { value: 'BGS 6', label: 'BGS 6 - EX-NM', gradingCompany: 'bgs' },
  { value: 'SGC 6', label: 'SGC 6 - EX-NM', gradingCompany: 'sgc', queryValue: 'SGC (6,80)' },
  { value: 'CGC 6', label: 'CGC 6 - EX-NM', gradingCompany: 'cgc' },
  { value: 'PSA 6/Auto 10', label: 'PSA 6/Auto 10 - EX-NM', gradingCompany: 'psa', queryValue: 'PSA 6' },
  { value: 'BGS 6/Auto 10', label: 'BGS 6/Auto 10 - EX-NM', gradingCompany: 'bgs', queryValue: 'BGS 6' },
  { value: 'SGC 6/Auto 10', label: 'SGC 6/Auto 10 - Mint', gradingCompany: 'sgc', queryValue: 'SGC (6,80)' },
  { value: 'PSA 5.5', label: 'PSA 5.5 - EX+', gradingCompany: 'psa' },
  { value: 'BGS 5.5', label: 'BGS 5.5 - EX+', gradingCompany: 'bgs' },
  { value: 'SGC 5.5', label: 'SGC 5.5 - EX+', gradingCompany: 'sgc', queryValue: 'SGC (5.5,70)' },
  { value: 'CGC 5.5', label: 'CGC 5.5 - EX+', gradingCompany: 'cgc' },
  { value: 'PSA 5', label: 'PSA 5 - EX', gradingCompany: 'psa' },
  { value: 'BGS 5', label: 'BGS 5 - EX', gradingCompany: 'bgs' },
  { value: 'SGC 5', label: 'SGC 5 - EX', gradingCompany: 'sgc', queryValue: 'SGC (5,60)' },
  { value: 'CGC 5', label: 'CGC 5 - EX', gradingCompany: 'cgc' },
  { value: 'PSA 5/Auto 10', label: 'PSA 5/Auto 10 - EX', gradingCompany: 'psa', queryValue: 'PSA 5' },
  { value: 'SGC 5/Auto 10', label: 'SGC 5/Auto 10 - Mint', gradingCompany: 'sgc', queryValue: 'SGC (5,60)' },
  { value: 'PSA 4.5', label: 'PSA 4.5 - VG-EX+', gradingCompany: 'psa' },
  { value: 'BGS 4.5', label: 'BGS 4.5 - VG-EX+', gradingCompany: 'bgs' },
  { value: 'SGC 4.5', label: 'SGC 4.5 - VG-EX+', gradingCompany: 'sgc', queryValue: 'SGC (4.5,55)' },
  { value: 'CGC 4.5', label: 'CGC 4.5 - VG-EX+', gradingCompany: 'cgc' },
  { value: 'PSA 4', label: 'PSA 4 - VG-EX', gradingCompany: 'psa' },
  { value: 'BGS 4', label: 'BGS 4 - VG-EX', gradingCompany: 'bgs' },
  { value: 'SGC 4', label: 'SGC 4 - VG-EX', gradingCompany: 'sgc', queryValue: 'SGC (4,50)' },
  { value: 'CGC 4', label: 'CGC 4 - VG-EX', gradingCompany: 'cgc' },
  { value: 'PSA 4/Auto 10', label: 'PSA 4/Auto 10 - VG-EX', gradingCompany: 'psa', queryValue: 'PSA 4' },
  { value: 'SGC 4/Auto 10', label: 'SGC 4/Auto 10 - Mint', gradingCompany: 'sgc', queryValue: 'SGC (4,50)' },
  { value: 'PSA 3.5', label: 'PSA 3.5 - VG+', gradingCompany: 'psa' },
  { value: 'BGS 3.5', label: 'BGS 3.5 - VG+', gradingCompany: 'bgs' },
  { value: 'SGC 3.5', label: 'SGC 3.5 - VG+', gradingCompany: 'sgc', queryValue: 'SGC (3.5,45)' },
  { value: 'CGC 3.5', label: 'CGC 3.5 - VG+', gradingCompany: 'cgc' },
  { value: 'PSA 3', label: 'PSA 3 - VG', gradingCompany: 'psa' },
  { value: 'BGS 3', label: 'BGS 3 - VG', gradingCompany: 'bgs' },
  { value: 'SGC 3', label: 'SGC 3 - VG', gradingCompany: 'sgc', queryValue: 'SGC (3,40)' },
  { value: 'CGC 3', label: 'CGC 3 - VG', gradingCompany: 'cgc' },
  { value: 'PSA 3/Auto 10', label: 'PSA 3/Auto 10 - VG', gradingCompany: 'psa', queryValue: 'PSA 3' },
  { value: 'PSA 2.5', label: 'PSA 2.5 - Good+', gradingCompany: 'psa' },
  { value: 'BGS 2.5', label: 'BGS 2.5 - Good+', gradingCompany: 'bgs' },
  { value: 'SGC 2.5', label: 'SGC 2.5 - Good+', gradingCompany: 'sgc', queryValue: 'SGC (2.5,35)' },
  { value: 'CGC 2.5', label: 'CGC 2.5 - Good+', gradingCompany: 'cgc' },
  { value: 'PSA 2', label: 'PSA 2 - Good', gradingCompany: 'psa' },
  { value: 'BGS 2', label: 'BGS 2 - Good', gradingCompany: 'bgs' },
  { value: 'SGC 2', label: 'SGC 2 - Good', gradingCompany: 'sgc', queryValue: 'SGC (2,30)' },
  { value: 'CGC 2', label: 'CGC 2 - Good', gradingCompany: 'cgc' },
  { value: 'PSA 2/Auto 10', label: 'PSA 2/Auto 10 - Good', gradingCompany: 'psa', queryValue: 'PSA 2' },
  { value: 'PSA 1.5', label: 'PSA 1.5 - Fair', gradingCompany: 'psa' },
  { value: 'BGS 1.5', label: 'BGS 1.5 - Fair', gradingCompany: 'bgs' },
  { value: 'SGC 1.5', label: 'SGC 1.5 - Fair', gradingCompany: 'sgc', queryValue: 'SGC (1.5,20)' },
  { value: 'CGC 1.5', label: 'CGC 1.5 - Fair', gradingCompany: 'cgc' },
  { value: 'PSA 1', label: 'PSA 1 - Poor', gradingCompany: 'psa', exclusions: ['PSA 10', 'PSA 9', 'PSA 8.5', 'PSA 8', 'PSA 7.5', 'PSA 7', 'PSA 6.5', 'PSA 6', 'PSA 5.5', 'PSA 5', 'PSA 4.5', 'PSA 4', 'PSA 3.5', 'PSA 3', 'PSA 2.5', 'PSA 2', 'PSA 1.5'] },
  { value: 'BGS 1', label: 'BGS 1 - Poor', gradingCompany: 'bgs' },
  { value: 'SGC 1', label: 'SGC 1 - Poor', gradingCompany: 'sgc' },
  { value: 'CGC 1', label: 'CGC 1 - Poor', gradingCompany: 'cgc' },
  { value: 'PSA 1/Auto 10', label: 'PSA 1/Auto 10 - Poor', gradingCompany: 'psa', queryValue: 'PSA 1' },
  { value: 'PSA Authentic', label: 'PSA Authentic', gradingCompany: 'psa', queryValue: 'PSA' },
  { value: 'BGS Authentic', label: 'BGS Authentic', gradingCompany: 'bgs', queryValue: 'BGS' },
  { value: 'SGC Authentic', label: 'SGC Authentic', gradingCompany: 'sgc', queryValue: 'SGC' },
  { value: 'CGC Authentic', label: 'CGC Authentic', gradingCompany: 'cgc', queryValue: 'CGC' },
  { value: 'PSA Authentic Altered', label: 'PSA Authentic Altered', gradingCompany: 'psa', queryValue: 'PSA' },
  { value: 'PSA Authentic/Auto 10', label: 'PSA Authentic/Auto 10', gradingCompany: 'psa', queryValue: 'PSA' },
  { value: 'SGC Authentic/Auto 10', label: 'SGC Authentic/Auto 10', gradingCompany: 'sgc', queryValue: 'SGC' },
  { value: 'Encased', label: 'Encased', queryValue: '' },
  { value: 'Sealed', label: 'Sealed', queryValue: '' },
  { value: 'TAG 10 Pristine', label: 'TAG 10 - Pristine', gradingCompany: 'tag' },
  { value: 'TAG 10 Gem Mint', label: 'TAG 10 - Gem Mint', gradingCompany: 'tag' },
  { value: 'TAG 9', label: 'TAG 9 - Mint', gradingCompany: 'tag' },
  { value: 'TAG 8.5', label: 'TAG 8.5 - NM-MT+', gradingCompany: 'tag' },
  { value: 'TAG 8', label: 'TAG 8 - NM-MT', gradingCompany: 'tag' },
  { value: 'TAG 7.5', label: 'TAG 7.5 - NM+', gradingCompany: 'tag' },
  { value: 'TAG 7', label: 'TAG 7 - NM', gradingCompany: 'tag' },
  { value: 'TAG 6.5', label: 'TAG 6.5 - EX-NM+', gradingCompany: 'tag' },
  { value: 'TAG 6', label: 'TAG 6 - EX-NM', gradingCompany: 'tag' },
  { value: 'TAG 5.5', label: 'TAG 5.5 - EX+', gradingCompany: 'tag' },
  { value: 'TAG 5', label: 'TAG 5 - EX', gradingCompany: 'tag' },
  { value: 'TAG 4.5', label: 'TAG 4.5 - VG-EX+', gradingCompany: 'tag' },
  { value: 'TAG 4', label: 'TAG 4 - VG-EX', gradingCompany: 'tag' },
  { value: 'TAG 3.5', label: 'TAG 3.5 - VG+', gradingCompany: 'tag' },
  { value: 'TAG 3', label: 'TAG 3 - VG', gradingCompany: 'tag' },
  { value: 'TAG 2.5', label: 'TAG 2.5 - Good+', gradingCompany: 'tag' },
  { value: 'TAG 2', label: 'TAG 2 - Good', gradingCompany: 'tag' },
  { value: 'TAG 1.5', label: 'TAG 1.5 - Fair', gradingCompany: 'tag' },
  { value: 'TAG 1', label: 'TAG 1 - Poor', gradingCompany: 'tag' },
  { value: 'CSG 10 Perfect', label: 'CSG 10 - Perfect', gradingCompany: 'csg' },
  { value: 'CSG 10', label: 'CSG 10 - Gem Mint', gradingCompany: 'csg' },
  { value: 'CSG 9.5', label: 'CSG 9.5 - Mint+', gradingCompany: 'csg' },
  { value: 'CSG 9', label: 'CSG 9 - Mint', gradingCompany: 'csg' },
  { value: 'CSG 8.5', label: 'CSG 8.5 - NM-MT+', gradingCompany: 'csg' },
  { value: 'CSG 8', label: 'CSG 8 - NM-MT', gradingCompany: 'csg' },
  { value: 'CSG 7.5', label: 'CSG 7.5 - NM+', gradingCompany: 'csg' },
  { value: 'CSG 7', label: 'CSG 7 - NM', gradingCompany: 'csg' },
  { value: 'CSG 6.5', label: 'CSG 6.5 - EX-NM+', gradingCompany: 'csg' },
  { value: 'CSG 6', label: 'CSG 6 - EX-NM', gradingCompany: 'csg' },
  { value: 'CSG 5.5', label: 'CSG 5.5 - EX+', gradingCompany: 'csg' },
  { value: 'CSG 5', label: 'CSG 5 - EX', gradingCompany: 'csg' },
  { value: 'CSG 4.5', label: 'CSG 4.5 - VG-EX+', gradingCompany: 'csg' },
  { value: 'CSG 4', label: 'CSG 4 - VG-EX', gradingCompany: 'csg' },
  { value: 'CSG 3.5', label: 'CSG 3.5 - VG+', gradingCompany: 'csg' },
  { value: 'CSG 3', label: 'CSG 3 - VG', gradingCompany: 'csg' },
  { value: 'CSG 2.5', label: 'CSG 2.5 - Good+', gradingCompany: 'csg' },
  { value: 'CSG 2', label: 'CSG 2 - Good', gradingCompany: 'csg' },
  { value: 'CSG 1.5', label: 'CSG 1.5 - Fair', gradingCompany: 'csg' },
  { value: 'CSG 1', label: 'CSG 1 - Poor', gradingCompany: 'csg' },
  { value: 'BVG 10', label: 'BVG 10 - Pristine', gradingCompany: 'bvg' },
  { value: 'BVG 9.5', label: 'BVG 9.5 - Gem Mint', gradingCompany: 'bvg' },
  { value: 'BVG 9', label: 'BVG 9 - Mint', gradingCompany: 'bvg' },
  { value: 'BVG 8.5', label: 'BVG 8.5 - NM-MT+', gradingCompany: 'bvg' },
  { value: 'BVG 8', label: 'BVG 8 - NM-MT', gradingCompany: 'bvg' },
  { value: 'BVG 7.5', label: 'BVG 7.5 - NM+', gradingCompany: 'bvg' },
  { value: 'BVG 7', label: 'BVG 7 - NM', gradingCompany: 'bvg' },
  { value: 'BVG 6.5', label: 'BVG 6.5 - EX-NM+', gradingCompany: 'bvg' },
  { value: 'BVG 6', label: 'BVG 6 - EX-NM', gradingCompany: 'bvg' },
  { value: 'BVG 5.5', label: 'BVG 5.5 - EX+', gradingCompany: 'bvg' },
  { value: 'BVG 5', label: 'BVG 5 - EX', gradingCompany: 'bvg' },
  { value: 'BVG 4.5', label: 'BVG 4.5 - VG-EX+', gradingCompany: 'bvg' },
  { value: 'BVG 4', label: 'BVG 4 - VG-EX', gradingCompany: 'bvg' },
  { value: 'BVG 3.5', label: 'BVG 3.5 - VG+', gradingCompany: 'bvg' },
  { value: 'BVG 3', label: 'BVG 3 - VG', gradingCompany: 'bvg' },
  { value: 'BVG 2.5', label: 'BVG 2.5 - Good+', gradingCompany: 'bvg' },
  { value: 'BVG 2', label: 'BVG 2 - Good', gradingCompany: 'bvg' },
  { value: 'BVG 1.5', label: 'BVG 1.5 - Fair', gradingCompany: 'bvg' },
  { value: 'BVG 1', label: 'BVG 1 - Poor', gradingCompany: 'bvg' },
  { value: 'HGA 10', label: 'HGA 10 - Pristine', gradingCompany: 'hga' },
  { value: 'HGA 9.5', label: 'HGA 9.5 - Gem Mint', gradingCompany: 'hga' },
  { value: 'HGA 9', label: 'HGA 9 - Mint', gradingCompany: 'hga' },
  { value: 'HGA 8.5', label: 'HGA 8.5 - NM-MT+', gradingCompany: 'hga' },
  { value: 'HGA 8', label: 'HGA 8 - NM-MT', gradingCompany: 'hga' },
  { value: 'HGA 7.5', label: 'HGA 7.5 - NM+', gradingCompany: 'hga' },
  { value: 'HGA 7', label: 'HGA 7 - NM', gradingCompany: 'hga' },
  { value: 'HGA 6.5', label: 'HGA 6.5 - EX-NM+', gradingCompany: 'hga' },
  { value: 'HGA 6', label: 'HGA 6 - EX-NM', gradingCompany: 'hga' },
  { value: 'HGA 5.5', label: 'HGA 5.5 - EX+', gradingCompany: 'hga' },
  { value: 'HGA 5', label: 'HGA 5 - EX', gradingCompany: 'hga' },
  { value: 'HGA 4.5', label: 'HGA 4.5 - VG-EX+', gradingCompany: 'hga' },
  { value: 'HGA 4', label: 'HGA 4 - VG-EX', gradingCompany: 'hga' },
  { value: 'HGA 3.5', label: 'HGA 3.5 - VG+', gradingCompany: 'hga' },
  { value: 'HGA 3', label: 'HGA 3 - VG', gradingCompany: 'hga' },
  { value: 'HGA 2.5', label: 'HGA 2.5 - Good+', gradingCompany: 'hga' },
  { value: 'HGA 2', label: 'HGA 2 - Good', gradingCompany: 'hga' },
  { value: 'HGA 1.5', label: 'HGA 1.5 - Fair', gradingCompany: 'hga' },
  { value: 'HGA 1', label: 'HGA 1 - Poor', gradingCompany: 'hga' },
  { value: 'OTHER 10', label: 'OTHER 10 - Pristine', gradingCompany: 'other' },
  { value: 'OTHER 9.5', label: 'OTHER 9.5 - Gem Mint', gradingCompany: 'other' },
  { value: 'OTHER 9', label: 'OTHER 9 - Mint', gradingCompany: 'other' },
  { value: 'OTHER 8.5', label: 'OTHER 8.5 - NM-MT+', gradingCompany: 'other' },
  { value: 'OTHER 8', label: 'OTHER 8 - NM-MT', gradingCompany: 'other' },
  { value: 'OTHER 7.5', label: 'OTHER 7.5 - NM+', gradingCompany: 'other' },
  { value: 'OTHER 7', label: 'OTHER 7 - NM', gradingCompany: 'other' },
  { value: 'OTHER 6.5', label: 'OTHER 6.5 - EX-NM+', gradingCompany: 'other' },
  { value: 'OTHER 6', label: 'OTHER 6 - EX-NM', gradingCompany: 'other' },
  { value: 'OTHER 5.5', label: 'OTHER 5.5 - EX+', gradingCompany: 'other' },
  { value: 'OTHER 5', label: 'OTHER 5 - EX', gradingCompany: 'other' },
  { value: 'OTHER 4.5', label: 'OTHER 4.5 - VG-EX+', gradingCompany: 'other' },
  { value: 'OTHER 4', label: 'OTHER 4 - VG-EX', gradingCompany: 'other' },
  { value: 'OTHER 3.5', label: 'OTHER 3.5 - VG+', gradingCompany: 'other' },
  { value: 'OTHER 3', label: 'OTHER 3 - VG', gradingCompany: 'other' },
  { value: 'OTHER 2.5', label: 'OTHER 2.5 - Good+', gradingCompany: 'other' },
  { value: 'OTHER 2', label: 'OTHER 2 - Good', gradingCompany: 'other' },
  { value: 'OTHER 1.5', label: 'OTHER 1.5 - Fair', gradingCompany: 'other' },
  { value: 'OTHER 1', label: 'OTHER 1 - Poor', gradingCompany: 'other' },
];

export const SEARCH_SOURCE_OPTIONS = [
  { value: 'salesarchive', label: 'Sales History', icon: 'point_of_sale', sort: 'date', isPublic: false },
  { value: 'profiles', label: 'Profiles', icon: 'style', sort: 'totalPopulation', isPublic: false, hideMobile: true },
  { value: 'cards', label: 'Ladder', icon: 'cl_ladder', sort: 'numSales', isPublic: true },
  { value: 'listings', label: 'Shop', icon: 'local_offer', sort: 'updatedDate', isPublic: true },
  { value: 'players', label: 'Players', icon: 'sports_handball', sort: 'totalCards', isPublic: true, hideMobile: true },
];

export const COLLECTION_CARD_ESTIMATE_OPTIONS = [
  {
    id: 'gradedcardautomatic',
    onSelect: 'chooseGradedCardProfile',
    icon: 'auto_awesome',
    title: 'Graded Card Automatic',
    description: 'If you have a graded card we can automatically update the value for you using our extensive sales history that matches to your exact card.',
  },
  {
    id: 'playerindex',
    onSelect: 'choosePlayerIndex',
    icon: 'person_search',
    title: 'Index + Purchase Price',
    description: 'Input your purchase price and date to automatically update the value based on the player index.',
    learnMoreLink: 'https://cardladder.zendesk.com/hc/en-us/articles/11943684520471--Card-Ladder-Value-The-Intersection-of-Player-Indexes-Price-Modeling',
  },
  {
    id: 'advanced',
    onSelect: 'chooseAdvanced',
    icon: 'point_of_sale',
    title: 'Index + Manual Sale',
    description: 'Search for a sale from our Sales History database and automatically update the value based on an index that you choose.',
    learnMoreLink: 'https://cardladder.zendesk.com/hc/en-us/articles/11943684520471--Card-Ladder-Value-The-Intersection-of-Player-Indexes-Price-Modeling',
  },
  {
    id: 'lastsale',
    onSelect: 'chooseLastSale',
    icon: 'build',
    title: 'Custom Sales Query',
    description: 'Write your own query to pull in sales to the card profile and use the latest sale to automatically update the value.',
    learnMoreLink: 'https://cardladder.zendesk.com/hc/en-us/articles/12047786944663-12-Rules-for-Writing-Search-Queries',
  },
  {
    id: 'multipliers',
    onSelect: 'chooseMultipliers',
    icon: 'calculate',
    title: 'Ladder + Multipliers',
    description: 'Search our verified cards and setup custom value ratios relative to those cards to get the value automatically.',
  },
  {
    id: 'manual',
    onSelect: 'chooseManual',
    icon: 'keyboard',
    title: 'Manual',
    description: 'Set the value of the card manually. Keep in mind this will not update automatically. We do not recommend this.',
  },
];

export const GRADING_COMPANY_UPLOAD_OPTIONS = [
  { value: 'psa', label: 'PSA' },
  { value: 'beckett', label: 'BECKETT' },
  { value: 'sgc', label: 'SGC' },
  { value: 'cgc', label: 'CGC' },
];

export const SENTRY_IGNORE_ERRORS = [
  'Non-Error promise rejection captured with value: Timeout',
  'Network Error',
  'timeout exceeded',
  'Failed to get document because the client is offline.',
  'Avoided redundant navigation to current location',
  'Firebase: A network AuthError',
  'An internal error occurred',
  'deadline-exceeded',
  'Your card was declined',
  'The email address is already in use by another account',
  'Missing data',
  'The operation failed for reasons unrelated to the database itself and not covered by any other error code',
  'Connection to Indexed Database server lost',
  'Blocked a frame with origin',
  'No document to update',
  'INTERNAL ASSERTION FAILED',
  'find variable: _AutofillCallbackHandler',
];
